import createCache from '@emotion/cache'
import { createTheme, ThemeOptions } from '@mui/material/styles'

import { theme as themeBa } from '@f-fertighaus/../@ba/styles/theme'
import { theme as themeBu } from '@f-fertighaus/../@bu/styles/theme'
import { theme as themeEh } from '@f-fertighaus/../@eh/styles/theme'
import { theme as themeFh } from '@f-fertighaus/../@f/styles/theme'
import { theme as themeIn } from '@f-fertighaus/../@in/styles/theme'
import { theme as themeIw } from '@f-fertighaus/../@iw/styles/theme'
import { theme as themeMh } from '@f-fertighaus/../@mh/styles/theme'

export const themeByDomain = {
  fertighaus: themeFh,
  massivhaus: themeMh,
  einfamilienhaus: themeEh,
  bungalow: themeBu,
  bauen: themeBa,
  immowelt: themeIw,
  immonet: themeIn
}

export const muiTheme = (theme: ThemeOptions) => createTheme(theme)

const isBrowser = typeof document !== 'undefined'
export const createEmotionCache = () => {
  let insertionPoint
  if (isBrowser) {
    const emotionInsertionPoint = document.querySelector(
      'meta[name="emotion-insertion-point"]'
    )
    insertionPoint = emotionInsertionPoint ?? undefined
  }
  return createCache({
    key: 'css',
    insertionPoint: insertionPoint as HTMLElement
  })
}

export const shadow = {
  card: '0 2px 50px 0 rgba(59, 71, 104, 0.05)',
  actionCard: `0 5px 10px -1px rgba(59, 71, 104, 0.05), 0 2px 4px -3px #3B4768, 0 2px 40px 0 rgba(59, 71, 104, 0.05)`,
  actionCardHover: `0 6px 8px -2px rgba(59, 71, 104, 0.3), 0 2px 4px -3px #3B4768, 0 2px 40px 0 rgba(59, 71, 104, 0.05)`
}
